<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZbpuVq/tc-custom/9780544032033.jpg?1737196001503" alt="This image is the cover for the book Lucky In The Corner"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lucky In The Corner
      </h1>
      <p class="bookDescription body article font2">
        <p>Nora and Fern are just like any other mother and daughter - their relationship is tumultuous, marked by brooding silences and curt exchanges. For Nora, Fern is an enigma - incomprehensible, unfindable. Fern has never really forgiven her mother for leaving her marriage to live with her lover, Jeanne. Their story is a contemporary one, in which mothering is a mapless journey and children are left to form themselves in the shadows cast by idiosyncratic parenting. Here, too, is the reality that perfectly reasonable people will find some way to throw a wrench into the smooth, well-oiled workings of their lives. Nora’s relationship with Jeanne has settled into domestic stability, triggering in Nora a familiar restlessness that leads to an affair. When Fern intuits her mother’s indiscretion, she looks to the two people she depends on most: her uncle Harold and her best friend, Tracy, who now has the overwhelming task of raising a baby. As Fern begins to take on more of the baby's care herself, she discovers some of the powerful ambiguities of parental love - and starts to find her way back to her own mother. <br/>Carol Anshaw has been praised for her "warmhearted sympathies and lively wit" (Newsday). LUCKY IN THE CORNER, with the author's inimitable humor and insight, shows us the way a family reconfigures itself as unexpected changes come its way - and how, no matter what shape it takes, it remains a family.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Anshaw
      </h2>
      
      <p class="authorDescription body article">Carol Anshaw is the author of <I>Aquamarine</I> and <I>Seven Moves,</I> both Lambda Award finalists. She has won the Carl Sandburg Award, the Society of Midland Authors Award, and a creative writing fellowship from the National Endowment for the Arts. A recipient of the National Book Critics Circle Citation for Excellence in Reviewing, she reviews books for major newspapers nationwide.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3eb79748